import { get } from '.';

export function FindGmRoHistoryLead(campaign_customer_id, options = {}) {
    return get<any>("/app/api/gm_ro_histories/" + (campaign_customer_id || 0).toString(), options);
}

export function GetGmRoHistory(options = {}) {
    return get<any>("/app/api/gm_ro_history", options);
}
